import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'

export function useIsCurrentUserGroup(groupId: string) {
	const { data: currentUser } = useQueryProfile()
	return currentUser?.userGroup?.id === groupId
}
